import { OrganizationKeyName } from "../../../../model/Organization";

export const GET_USER_VOUCHER = "SHOP:GET_USER_VOUCHER";

export const getUserVoucherAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_USER_VOUCHER as typeof GET_USER_VOUCHER,
  organization,
  id,
});

export type GetUserVoucherAction = ReturnType<typeof getUserVoucherAction>;
